// extracted by css-extract-rspack-plugin
module.exports =  {"root":"ProgressionMessageContent__root___GeTxM"};